module.exports = __webpack_public_path__ + "media/images/media/media2-e7e8b610171b44b1cbb6603837bb5733.jpg";